(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8638,9524],{

/***/ 12066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./EngineeringImages": [
		31357,
		1357
	],
	"./MarketingImages": [
		53290,
		3290
	],
	"./ProductImages": [
		2958,
		2958
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 12066;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 60716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./EngineeringImages": 31357,
	"./MarketingImages": 53290,
	"./ProductImages": 2958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 60716;
module.exports = webpackContext;

/***/ }),

/***/ 93228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 82941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(93228),
    isIterateeCall = __webpack_require__(82406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(82941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 34353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sv": function() { return /* binding */ AudienceImage; },
  "tq": function() { return /* binding */ AudienceTestimonialLogo; },
  "Tr": function() { return /* binding */ audienceCarouselLogos; }
});

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 250 modules
var CompanyMono = __webpack_require__(68536);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
;// CONCATENATED MODULE: ../../libs/utils/capitalizeFirstLetter/capitalizeFirstLetter.ts
/**
 * Capitalize the first letter of a string
 * @param string - The string to capitalize
 * @returns The string with the first letter capitalized
 */
var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/* harmony default export */ var capitalizeFirstLetter_capitalizeFirstLetter = (capitalizeFirstLetter);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/data/signUp/components/index.tsx







var AudienceTestimonialLogo = function AudienceTestimonialLogo(_ref) {
  var audience = _ref.audience;

  var renderByAudience = function renderByAudience() {
    switch (audience) {
      case "marketing":
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MongoDbMonoLogo */.N2M, {
          color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
        });

      case "product":
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DailyHarvestMonoLogo */.x5z, {
          color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
        });

      case "engineering":
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* DailyHarvestMonoLogo */.x5z, {
          color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
        });

      default:
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* MongoDbMonoLogo */.N2M, {
          color: Theme/* default.palette.neutrals.white.100 */.ZP.palette.neutrals.white[100]
        });
    }
  };

  return renderByAudience();
};

var audienceCarouselLogos = function audienceCarouselLogos(audience) {
  var defaultData = [data/* carouselLogos.DIGITAL_OCEAN */.j.DIGITAL_OCEAN, data/* carouselLogos.IBM */.j.IBM, data/* carouselLogos.DOMINOS */.j.DOMINOS, data/* carouselLogos.ANHEUSER_BUSCH */.j.ANHEUSER_BUSCH, data/* carouselLogos.VMWARE */.j.VMWARE, data/* carouselLogos.LEVIS */.j.LEVIS, data/* carouselLogos.LOG_ME_IN */.j.LOG_ME_IN, data/* carouselLogos.CLEAR_SCORE */.j.CLEAR_SCORE, data/* carouselLogos.VACASA */.j.VACASA, data/* carouselLogos.STAPLES */.j.STAPLES, data/* carouselLogos.INTUIT */.j.INTUIT, data/* carouselLogos.THE_SKIMM */.j.THE_SKIMM, data/* carouselLogos.DRIFT */.j.DRIFT, data/* carouselLogos.ALLERGAN */.j.ALLERGAN, data/* carouselLogos.GLOSSIER */.j.GLOSSIER, data/* carouselLogos.AB_IN_BEV */.j.AB_IN_BEV];

  switch (audience) {
    case "marketing":
      return defaultData;

    case "product":
      return [data/* carouselLogos.DIGITAL_OCEAN */.j.DIGITAL_OCEAN, data/* carouselLogos.ALLERGAN */.j.ALLERGAN, data/* carouselLogos.GLOSSIER */.j.GLOSSIER, data/* carouselLogos.AB_IN_BEV */.j.AB_IN_BEV];

    case "engineering":
      return [data/* carouselLogos.DIGITAL_OCEAN */.j.DIGITAL_OCEAN, data/* carouselLogos.ALLERGAN */.j.ALLERGAN, data/* carouselLogos.GLOSSIER */.j.GLOSSIER, data/* carouselLogos.AB_IN_BEV */.j.AB_IN_BEV];

    default:
      return defaultData;
  }
};

var AudienceImage = function AudienceImage(_ref2) {
  var audience = _ref2.audience;
  var Images = dynamic_default()(function () {
    return __webpack_require__(12066)("./".concat(capitalizeFirstLetter_capitalizeFirstLetter(audience), "Images"));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(__webpack_require__(60716).resolve("./".concat(capitalizeFirstLetter_capitalizeFirstLetter(audience), "Images")))];
      }
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Images, {});
};



/***/ }),

/***/ 40956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignUp; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(82680);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/SignUp/components/Navigation/DesktopNavigation.tsx










var NavigationDesktop = function NavigationDesktop(_ref) {
  var announcement = _ref.announcement,
      buttonText = _ref.buttonText,
      buttonLink = _ref.buttonLink,
      after = _ref.after;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* Navbar */.wp, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navbar/* Aside */.xN, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          tag: "span",
          variant: "pSmall",
          children: "Already have an account?"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          size: "small",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("".concat(buttonLink), pageConfig),
          variant: "mono",
          children: buttonText
        })]
      })]
    }), after]
  });
};

/* harmony default export */ var Navigation_DesktopNavigation = (NavigationDesktop);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var MobileNavigation_Navbar = __webpack_require__(90806);
;// CONCATENATED MODULE: ./src/views/SignUp/components/Navigation/MobileNavigation.tsx










var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      buttonText = _ref.buttonText,
      buttonLink = _ref.buttonLink,
      after = _ref.after;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* Navbar */.wp, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation_Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
        size: "small",
        tag: "a",
        href: (0,getAbsoluteUrl/* default */.Z)("".concat(buttonLink), pageConfig),
        variant: "mono",
        children: buttonText
      })]
    }), after]
  });
};

/* harmony default export */ var components_Navigation_MobileNavigation = (MobileNavigation);
;// CONCATENATED MODULE: ./src/views/SignUp/components/Navigation/Navigation.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var copy = {
  buttonText: "Log in",
  buttonLink: "/login"
};

var Navigation = function Navigation() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation, _objectSpread({}, copy))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Navigation_MobileNavigation, _objectSpread({}, copy))
    })]
  });
};

var NavAside = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "e7xola0"
} : 0)("display:grid;gap:24px;grid-auto-flow:column;justify-content:space-between;align-items:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("sm");
}, "{display:", function (_ref2) {
  var hideOnMobile = _ref2.hideOnMobile;
  return hideOnMobile ? "none" : "grid";
}, ";}" + ( true ? "" : 0))));
/* harmony default export */ var Navigation_Navigation = (Navigation);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var regexes_email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ../../libs/templates/Forms/SignUpForm/data.ts

var richTextDisclaimer = function richTextDisclaimer(buttonText) {
  return {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "By clicking \"".concat(buttonText, "\" you agree to our "),
        nodeType: "text"
      }, {
        data: {
          uri: "https://www.twilio.com/legal/tos"
        },
        content: [{
          data: {},
          marks: [],
          value: "Terms of Service",
          nodeType: "text"
        }],
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: " and ",
        nodeType: "text"
      }, {
        data: {
          uri: "https://www.twilio.com/legal/privacy/"
        },
        content: [{
          data: {},
          marks: [],
          value: "Privacy Notice",
          nodeType: "text"
        }],
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: ".",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  };
};
;// CONCATENATED MODULE: ../../libs/templates/Forms/SignUpForm/SignupForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ehpzz1l0"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/SignUpForm/SignupForm.tsx



var _excluded = ["appearance", "className", "successMessageAppearance", "submitButtonText", "customFormIdentifier", "customTrackingType", "overrideConsent", "emailValidator", "onSubmit"];

function SignupForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SignupForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SignupForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SignupForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/* eslint-disable react-hooks/exhaustive-deps */




















var FORM_ID = "site-marketing-workspace";
var EMAIL_ERROR_MESSAGE = "This email is already in use.";

var SignUpForm = function SignUpForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      successMessageAppearance = _ref.successMessageAppearance,
      _ref$submitButtonText = _ref.submitButtonText,
      submitButtonText = _ref$submitButtonText === void 0 ? "Sign up" : _ref$submitButtonText,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      overrideConsent = _ref.overrideConsent,
      emailValidator = _ref.emailValidator,
      onSubmit = _ref.onSubmit,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl,
      params = _usePageConfig.queryParamsFromCookie;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isValidating = _useState2[0],
      setIsValidating = _useState2[1];

  var _useState3 = (0,react.useState)(undefined),
      isEmailAllowed = _useState3[0],
      setEmailAllowed = _useState3[1];

  var _useState4 = (0,react.useState)({
    isValid: undefined,
    isStrong: true,
    isCompromised: false,
    errorMessage: ""
  }),
      passwordStrength = _useState4[0],
      setPasswordStrength = _useState4[1];

  var formErrorMessage = (0,react.useMemo)(function () {
    return {
      heading: "Something happened",
      description: "We are really sorry. There was an error processing your submission. You can still create your free Segment account on our sign up page. You'll reenter your information on a new page, but gain access to all the same great features.",
      buttonUrl: "".concat(baseUrl, "/signup/").concat(params ? "?".concat(params) : ""),
      buttonText: "Sign up"
    };
  }, [baseUrl, params]);

  var handleEmailValidation = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(email) {
      var isValidEmail;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!regexes_email/* default.test */.Z.test(email)) {
                _context.next = 18;
                break;
              } // Just call the validator if the email anatomy is correct.


              setIsValidating(true);
              _context.prev = 2;
              _context.next = 5;
              return emailValidator(email);

            case 5:
              isValidEmail = _context.sent;
              setEmailAllowed(isValidEmail);
              return _context.abrupt("return", {
                valid: isValidEmail,
                message: isValidEmail ? "" : EMAIL_ERROR_MESSAGE
              });

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              _context.next = 14;
              return (0,scripts/* trackServerError */.qv)({}, customFormIdentifier || "", JSON.stringify(_context.t0));

            case 14:
              methods.setError("root.serverError", {
                type: "400"
              });

            case 15:
              _context.prev = 15;
              setIsValidating(false);
              return _context.finish(15);

            case 18:
              return _context.abrupt("return", {
                valid: false,
                message: EMAIL_ERROR_MESSAGE
              });

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10, 15, 18]]);
    }));

    return function handleEmailValidation(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handlePasswordValidation = (0,react.useCallback)(function (isValid, isStrong, isCompromised, errorMessage) {
    var apiError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var isLoading = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (apiError) {
      (0,scripts/* trackServerError */.qv)({
        apiError: "true"
      }, customFormIdentifier || "", JSON.stringify(apiError));
      methods.setError("root.serverError", {
        type: "400"
      });
    } else {
      setPasswordStrength({
        isValid: isValid,
        isStrong: isStrong,
        isCompromised: isCompromised,
        errorMessage: errorMessage
      });
      setIsValidating(isLoading);
    }
  }, []);
  var schema = (0,react.useMemo)(function () {
    return lib/* object */.Ry({
      email: lib/* string */.Z_().min(1, {
        message: FormFields/* companyEmailMessages.required */.BN.required
      }).email(FormFields/* companyEmailMessages.invalid */.BN.invalid).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).refine(function () {
        return isEmailAllowed === undefined || isEmailAllowed;
      }, {
        message: EMAIL_ERROR_MESSAGE
      }),
      name: lib/* string */.Z_().min(1, {
        message: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      password: lib/* string */.Z_().refine(function () {
        return passwordStrength.isValid;
      }, {
        message: passwordStrength.errorMessage
      })
    });
  }, [passwordStrength.errorMessage, passwordStrength.isValid, isEmailAllowed]);
  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  (0,react.useEffect)(function () {
    if (isEmailAllowed !== undefined && methods.formState.dirtyFields.email) {
      methods.trigger("email");
    }
  }, [isEmailAllowed]);
  (0,react.useEffect)(function () {
    if (passwordStrength.isValid !== undefined) {
      methods.trigger("password");
    }
  }, [passwordStrength.isValid]);

  var submitCallback = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.prev = 1;
              (0,scripts/* track */.j)("Workspace Signup Initiated", {
                email: data.email,
                formId: customFormIdentifier || FORM_ID
              });
              _context2.next = 5;
              return onSubmit(data);

            case 5:
              _context2.next = 12;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              (0,scripts/* trackServerError */.qv)({
                email: data.email,
                formId: customFormIdentifier || FORM_ID
              }, customFormIdentifier || "", JSON.stringify(_context2.t0));
              setLoading(false);
              methods.setError("root.serverError", {
                type: "400"
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));

    return function submitCallback(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, SignupForm_objectSpread(SignupForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, SignupForm_objectSpread({
          status: "error",
          appearance: successMessageAppearance,
          "data-hook": "signup-error-message"
        }, formErrorMessage)),
        onSubmit: function onSubmit(data) {
          submitCallback(data);
        },
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType,
        "data-hook": "signup-form",
        keepFieldsAfterSuccess: true
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onValidate: handleEmailValidation
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PasswordField */.ZI, {
          onValidate: handlePasswordValidation
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          color: "primary",
          variant: "filled",
          size: "large",
          expanded: true,
          isLoading: isLoading,
          disabled: isValidating,
          children: submitButtonText
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          data: richTextDisclaimer(submitButtonText),
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};

/* harmony default export */ var SignupForm = (SignUpForm);
;// CONCATENATED MODULE: ../../libs/templates/Forms/SignUpForm/index.ts

// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/signup.ts
var signup = __webpack_require__(61157);
// EXTERNAL MODULE: ./src/views/SignUp/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(63324);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/SignUp/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(50675);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/SignUp/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(40633);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
;// CONCATENATED MODULE: ./src/views/SignUp/components/Hero/Hero.tsx




function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var talkToSalesButton = {
  title: "Talk to sales",
  link: "/demo/"
};

var Hero = function Hero(_ref) {
  var heading = _ref.heading,
      copy = _ref.copy,
      formId = _ref.formId;

  var _useState = (0,react.useState)(417),
      formSize = _useState[0],
      setFormSize = _useState[1];

  var router = (0,next_router.useRouter)();
  var handleEmailValidation = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(email) {
      var controller, response, valid;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              controller = new AbortController();
              _context.next = 3;
              return (0,signup/* fetchUserExists */.T3)(controller.signal, email);

            case 3:
              response = _context.sent;
              valid = response.userExists === false;
              return _context.abrupt("return", valid);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var handleSubmit = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
      var name, email, password, controller, response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              name = data.name, email = data.email, password = data.password;
              controller = new AbortController();
              _context2.next = 4;
              return (0,signup/* fetchSignup */.dI)(controller.signal, {
                name: name,
                email: email,
                password: password
              });

            case 4:
              response = _context2.sent;

              if (!(response.success && response.redirectUrl)) {
                _context2.next = 9;
                break;
              }

              router.push(response.redirectUrl);
              _context2.next = 12;
              break;

            case 9:
              (0,scripts/* trackErrorSignupForm */.wk)({
                name: name,
                email: email
              }, String(response.message));
              setFormSize(440);
              throw new Error(response.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [router]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_Wrapper, {
    id: "sign-up-hero-form",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyTextHeading, {
            tag: "h1",
            variant: "h2",
            children: heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            dangerouslySetInnerHTML: {
              __html: sanitize_html_default()(copy, {
                allowedTags: ["a"]
              })
            }
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroRecipeCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormWrapper, {
          size: formSize,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupForm, {
            customFormIdentifier: formId,
            customTrackingType: formId,
            onSubmit: handleSubmit,
            emailValidator: handleEmailValidation
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
            href: talkToSalesButton.link,
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: talkToSalesButton.title,
                targetUrl: talkToSalesButton.link
              });
            },
            iconEnd: Common/* ChevronRightIcon */.XC,
            children: "Talk to sales"
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "640",
            height: "400",
            src: (Hero_2x_default()),
            alt: "Illustration: Dashboard",
            loading: "lazy"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var Hero_Hero = (Hero);

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e238ohu5"
} : 0)("background:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var HeroRecipeCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Copy */.CK,  true ? {
  target: "e238ohu4"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("md");
}, "{margin:0 auto;}" + ( true ? "" : 0));

var CopyTextHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e238ohu3"
} : 0)("max-width:220px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("xs");
}, "{max-width:unset;}" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e238ohu2"
} : 0)(Section/* Wrapper */.im, "{gap:0;padding-bottom:0;}" + ( true ? "" : 0));

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e238ohu1"
} : 0)("max-width:", function (_ref7) {
  var size = _ref7.size;
  return "".concat(size, "px");
}, ";", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.down("md");
}, "{max-width:100%;}" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e238ohu0"
} : 0)( true ? {
  name: "1ghu3wd",
  styles: "padding-top:24px"
} : 0);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
;// CONCATENATED MODULE: ./src/views/SignUp/components/GettingStarted/GettingStarted.tsx










var GettingStarted_copy = {
  heading: "Start connecting your data with Segment",
  button: {
    text: "Create a free account"
  },
  demoButton: {
    text: "Talk to sales",
    href: "/demo/"
  }
};

var GettingStarted = function GettingStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: GettingStarted_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          onClick: function onClick() {
            return (0,useScrollToAnchor/* scrollToAnchor */.d)("sign-up-hero-form", -80);
          },
          children: GettingStarted_copy.button.text
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "outlined",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)(GettingStarted_copy.demoButton.href, pageConfig),
          onClick: function onClick() {
            return (0,scripts/* trackButtonClick */.kO)({
              buttonText: GettingStarted_copy.demoButton.text,
              targetUrl: GettingStarted_copy.demoButton.href
            });
          },
          children: GettingStarted_copy.demoButton.text
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  });
};

var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bctm6s2"
} : 0)("overflow-y:auto;overflow-x:hidden;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bctm6s1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:40px 0 20px;white-space:pre-line;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bctm6s0"
} : 0)("display:grid;max-width:520px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
/* harmony default export */ var GettingStarted_GettingStarted = (GettingStarted);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
;// CONCATENATED MODULE: ./src/views/SignUp/components/MainSection/MainSection.tsx


function MainSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var MainSection = function MainSection(_ref) {
  var heading = _ref.heading,
      description = _ref.description,
      image = _ref.image;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBaseWrapper, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainSection_StyledSectionBase, {
        variant: "2Col",
        reverse: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              children: heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
                data: description
              })
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
          children: image
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var MainSection_MainSection = (MainSection);

var SectionBaseWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1niyoxm2"
} : 0)(Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:0;padding-bottom:0;}}" + ( true ? "" : 0));

var MainSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1niyoxm1"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:120px;padding-bottom:120px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("xs");
}, "{padding:0 0 40px;grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1niyoxm0"
} : 0)( true ? {
  name: "qbt5ty",
  styles: "align-self:center"
} : 0);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
;// CONCATENATED MODULE: ./src/views/SignUp/components/LogoCarousel/LogoCarousel.tsx


var LogoCarousel_excluded = ["heading", "logos"];

function LogoCarousel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LogoCarousel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LogoCarousel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LogoCarousel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, LogoCarousel_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, LogoCarousel_objectSpread(LogoCarousel_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: externalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/SignUp/components/PlanFeatures/assets/PlanFeatures@2x.png
var PlanFeatures_2x = __webpack_require__(7868);
var PlanFeatures_2x_default = /*#__PURE__*/__webpack_require__.n(PlanFeatures_2x);
// EXTERNAL MODULE: ./src/views/SignUp/components/PlanFeatures/assets/PlanFeatures.webp
var PlanFeatures = __webpack_require__(32247);
var PlanFeatures_default = /*#__PURE__*/__webpack_require__.n(PlanFeatures);
// EXTERNAL MODULE: ./src/views/SignUp/components/PlanFeatures/assets/PlanFeatures@2x.webp
var assets_PlanFeatures_2x = __webpack_require__(71975);
var assets_PlanFeatures_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PlanFeatures_2x);
;// CONCATENATED MODULE: ./src/views/SignUp/components/PlanFeatures/PlanFeaturesImage.tsx







var PlanFeaturesImage = function PlanFeaturesImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((PlanFeatures_default()), ", ").concat((assets_PlanFeatures_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "484",
      src: (PlanFeatures_2x_default()),
      alt: "Illustration: Plan Features",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var PlanFeatures_PlanFeaturesImage = (PlanFeaturesImage);
;// CONCATENATED MODULE: ./src/views/SignUp/components/PlanFeatures/PlanFeatures.tsx


function PlanFeatures_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var PlanFeatures_copy = {
  heading: "Your free plan includes:",
  description: ["Data collection from 2 sources of your choice", "Unlimited data distribution", "Up to 1,000 monthly users", "500,000 Reverse ETL records per month", "1 data warehouse", "450+ pre-built integrations", "Developer tools and debugger", "Data and privacy controls", "10 seats"],
  linkText: "Compare Segment pricing plans",
  linkHref: "/pricing/"
};

var PlanFeatures_PlanFeatures = function PlanFeatures(_ref) {
  var logos = _ref.logos;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanFeatures_SectionBaseWrapper, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlanFeatures_StyledSectionBase, {
        variant: "2Col",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              variant: "h2",
              tag: "h1",
              children: PlanFeatures_copy.heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                children: PlanFeatures_copy.description.map(function (desc, idx) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledListItem, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Benefit, {
                      variant: "pLarge",
                      children: desc
                    })
                  }, "desc-".concat(idx));
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
              href: (0,getAbsoluteUrl/* default */.Z)(PlanFeatures_copy.linkHref, pageConfig),
              iconEnd: Common/* ChevronRightIcon */.XC,
              children: PlanFeatures_copy.linkText
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanFeatures_PlanFeaturesImage, {})
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLogoCarousel, {
        logos: logos
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var components_PlanFeatures_PlanFeatures = (PlanFeatures_PlanFeatures);

var PlanFeatures_SectionBaseWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e17ohdw95"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:0;}}" + ( true ? "" : 0));

var PlanFeatures_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e17ohdw94"
} : 0)(Section/* Wrapper */.im, "{", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("md");
}, "{gap:80px;padding-top:120px;padding-bottom:80px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("xs");
}, "{padding:0 0 40px;}}" + ( true ? "" : 0));

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e17ohdw93"
} : 0)("margin-bottom:24px;padding-left:16px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("lg");
}, "{margin-bottom:0;}" + ( true ? "" : 0));

var StyledListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e17ohdw92"
} : 0)( true ? {
  name: "1s3jk2e",
  styles: "list-style-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.045.667a.91.91 0 0 1 .025 1.305L5.031 8.126a.95.95 0 0 1-1.356 0L.93 5.33a.91.91 0 0 1 .025-1.305.954.954 0 0 1 1.331.025l2.067 2.106L9.714.692a.954.954 0 0 1 1.33-.025Z' fill='%23121C2D'/%3e%3c/svg%3e \");font-weight:400;padding:0 0 8px 8px"
} : 0);

var Benefit = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e17ohdw91"
} : 0)( true ? {
  name: "wgm2x7",
  styles: "margin:0;display:flex;gap:8px"
} : 0);

var StyledLogoCarousel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LogoCarousel_LogoCarousel,  true ? {
  target: "e17ohdw90"
} : 0)("padding-bottom:60px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{padding-bottom:120px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Testimonial/index.ts + 11 modules
var Testimonial = __webpack_require__(60814);
;// CONCATENATED MODULE: ./src/views/SignUp/components/SeeHowYouCan/Testimonial.tsx




var TestimonialPlaybook = function TestimonialPlaybook(_ref) {
  var data = _ref.data,
      testimonialLogo = _ref.testimonialLogo;
  var text = data.text,
      author = data.author,
      tData = data.data;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* default */.ZP, {
    variant: "base",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Base */.XY, {
      height: "auto",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* BaseContentSlot */.b6, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseLogo */.jo, {
          children: testimonialLogo
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseText */.k$, {
          children: text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* BaseAuthorSlot */.hC, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* AuthorInfo */.d7, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorName */.U2, {
            children: author.name
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* AuthorPosition */.a6, {
            children: author.title
          })]
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* Extended */.jW, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedTextSlot */.VJ, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Testimonial/* ExtendedHeader */.S2, {
          children: [tData.rate, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedHeaderSup */.Jk, {
            children: tData.sign
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedText */.wN, {
          children: tData.text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButtonSlot */.Wi, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedStoryLink */.c9, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial/* ExtendedButton */.Di, {
            href: tData.link,
            text: "Read their story"
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var SeeHowYouCan_Testimonial = (TestimonialPlaybook);
;// CONCATENATED MODULE: ./src/views/SignUp/components/SeeHowYouCan/SeeHowYouCan.tsx


function SeeHowYouCan_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var SeeHowYouCan = function SeeHowYouCan(_ref) {
  var playbook = _ref.playbook,
      testimonialLogo = _ref.testimonialLogo;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          children: playbook.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: playbook.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SeeHowYouCan_StyledSectionBase, {
        variant: "2Col",
        reverse: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              children: playbook.steps.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureWrapper, {
                children: playbook.steps.items.map(function (step, idx) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
                    alignment: "left",
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                        children: step.title
                      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                        children: step.description
                      })]
                    })
                  }, "playbook-".concat(idx));
                })
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
              href: playbook.recipeLink,
              children: "Use this recipe"
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeeHowYouCan_Testimonial, {
            data: playbook.testimonial,
            testimonialLogo: testimonialLogo
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var SeeHowYouCan_SeeHowYouCan = (SeeHowYouCan);

var MainSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1xehm0d2"
} : 0)(Section/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-top:120px;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("xs");
}, "{padding-top:0;}}" + ( true ? "" : 0));

var SeeHowYouCan_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1xehm0d1"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-right:0;padding-left:0;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:120px;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:80px;}", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.down("xs");
}, "{padding:0;}", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.down("md");
}, "{grid-template-areas:'contents' 'copy';}}" + ( true ? "" : 0));

var FeatureWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xehm0d0"
} : 0)( true ? {
  name: "zx0zmy",
  styles: "display:grid;gap:24px;grid-template-rows:1fr"
} : 0);
// EXTERNAL MODULE: ./src/views/SignUp/assets/OgImage.png
var OgImage = __webpack_require__(74687);
var OgImage_default = /*#__PURE__*/__webpack_require__.n(OgImage);
;// CONCATENATED MODULE: ./src/views/SignUp/SignUp.tsx



function SignUp_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SignUp_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SignUp_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SignUp_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var SignUpView = function SignUpView(props) {
  var hero = props.hero,
      main = props.main,
      logos = props.logos,
      playbook = props.playbook,
      metadata = props.metadata,
      image = props.image,
      testimonialLogo = props.testimonialLogo;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: metadata.title,
      pageDescription: metadata.description,
      themeColor: theme.palette.twilio.gray[10],
      bodyBackground: theme.palette.twilio.gray[10],
      pageOG: (OgImage_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_Navigation, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, SignUp_objectSpread({}, hero)), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainSection_MainSection, SignUp_objectSpread(SignUp_objectSpread({}, main), {}, {
          image: image
        })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PlanFeatures_PlanFeatures, {
          logos: logos
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeeHowYouCan_SeeHowYouCan, {
          playbook: playbook,
          testimonialLogo: testimonialLogo
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_GettingStarted, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var SignUp = (SignUpView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "eir4ts60"
} : 0)("overflow:hidden;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 69524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FooterCompact; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/useTrustArcLink.ts
var useTrustArcLink = __webpack_require__(9642);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/FooterCompact/FooterCompact.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var MenuItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "eaptrme6"
} : 0)("color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";display:flex;align-self:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("sm");
}, "{text-align:center;margin:5px 0;}" + ( true ? "" : 0));
var MenuLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "eaptrme5"
} : 0)("color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";text-decoration:underline;" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eaptrme4"
} : 0)("width:100%;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.pSmall;
}, " padding:10px 40px 0;background:", function (_ref5) {
  var background = _ref5.background;
  return background;
}, ";", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{padding:10px 80px 0;}" + ( true ? "" : 0));
var DividerLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eaptrme3"
} : 0)( true ? {
  name: "x85wbw",
  styles: "padding:0 5px"
} : 0);
var FooterContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("footer",  true ? {
  target: "eaptrme2"
} : 0)("margin:0 auto;padding:35px 0 40px;display:grid;grid-template-columns:none;gap:28px;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("md");
}, "{grid-template-columns:1fr auto;grid-template-rows:none;gap:80px;max-width:1280px;}" + ( true ? "" : 0));
var MenuLinks = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "eaptrme1"
} : 0)("margin:0;padding:0;display:flex;", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.down("sm");
}, "{flex-wrap:wrap;justify-content:center;}" + ( true ? "" : 0));
var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eaptrme0"
} : 0)("display:grid;grid-template-columns:1fr;", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.down("sm");
}, "{>*:first-child{margin:0 auto;}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/templates/FooterCompact/FooterCompact.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var data = {
  bottomLinks: [{
    url: "https://www.twilio.com/legal/privacy/",
    title: "Privacy"
  }, {
    url: "https://www.twilio.com/legal/tos/",
    title: "Terms"
  }],
  copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
};

var BaseFooterCompact = function BaseFooterCompact(_ref) {
  var tokens = _ref.tokens,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? false : _ref$divider,
      backgroundColor = _ref.backgroundColor;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var hasTrustArcEnabled = (0,useTrustArcLink/* default */.Z)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    background: backgroundColor || tokens.background,
    children: [divider && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterContent, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            appearance: tokens.logoAppearance,
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuLinks, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, _objectSpread(_objectSpread({}, tokens.menuItem), {}, {
          children: data.copyright
        })), data.bottomLinks.map(function (_ref2) {
          var title = _ref2.title,
              url = _ref2.url;
          return (0,emotion_react_browser_esm/* createElement */.az)(MenuItem, _objectSpread(_objectSpread({}, tokens.menuItem), {}, {
            key: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerLine, {
            children: "|"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLink, _objectSpread(_objectSpread({}, tokens.menuLink), {}, {
            href: url,
            children: title
          })));
        }), hasTrustArcEnabled && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItem, _objectSpread(_objectSpread({}, tokens.menuItem), {}, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerLine, {
            children: "|"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLink, _objectSpread(_objectSpread({}, tokens.menuLink), {}, {
            id: "teconsent"
          }))]
        }))]
      })]
    })]
  });
};

var FooterCompact = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFooterCompact, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      menuItem: {
        color: theme.palette.twilio.gray[100]
      },
      menuLink: {
        color: theme.palette.twilio.gray[100]
      },
      logoAppearance: "light"
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      menuItem: {
        color: theme.palette.twilio.gray[100]
      },
      menuLink: {
        color: theme.palette.twilio.gray[100]
      },
      logoAppearance: "light"
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      menuItem: {
        color: theme.palette.twilio.gray[100]
      },
      menuLink: {
        color: theme.palette.twilio.gray[100]
      },
      logoAppearance: "light"
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      background: theme.palette.twilio.gray[100],
      menuItem: {
        color: theme.palette.neutrals.white[100]
      },
      menuLink: {
        color: theme.palette.neutrals.white[100]
      },
      logoAppearance: "twilioDark"
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      menuItem: {
        color: theme.palette.twilio.gray[100]
      },
      menuLink: {
        color: theme.palette.twilio.gray[100]
      },
      logoAppearance: "light"
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/FooterCompact/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 74687:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImage-3cdd21a0698773bca839d36dc81ba609.png";

/***/ }),

/***/ 63324:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-811be9ab17e8d8551b3af3d4836ddc0b.png";

/***/ }),

/***/ 7868:
/***/ (function(module) {

module.exports = "/_next/static/images/PlanFeatures@2x-23f946595b49bb554ad2efe62ecc4a49.png";

/***/ }),

/***/ 50675:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-7634169d2bd7fa74f06ea0139e6c809f.webp";

/***/ }),

/***/ 40633:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-09c5eebf8059b1ccdb435901de8aa07e.webp";

/***/ }),

/***/ 32247:
/***/ (function(module) {

module.exports = "/_next/static/images/PlanFeatures-cde3272cf85ba7c8d5f44dfc75237426.webp";

/***/ }),

/***/ 71975:
/***/ (function(module) {

module.exports = "/_next/static/images/PlanFeatures@2x-485c8c71062b9b0d34503eaf38adf8c5.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ })

}]);